export * from './login/login.component';
export * from './forget/forget.component';
export * from './sign-up/sign-up.component';
